import { DEFAULT_BRAND } from '@vedalib/editor/lib/brand'
import React from 'react'

import { UseAbsoluteSizes } from 'components/Editor/DeviceEmulator/hooks'
import type { CommentMock } from 'components/comments/types'
import type { TaskMock } from 'components/uiKit/Task'
import { EMPTY_ARRAY } from 'constants/commonConstans'
import BrandProvider from 'services/Branding/BrandProvider'
import type { BrandType } from 'services/Branding/types'
import MediaProvider from 'services/Media/MediaProvider'
import { ProjectLabelsProvider } from 'services/ProjectLabels'
import { FontsInjector } from 'utils/font/injectors'

import { PreviewMode } from './enums'
import type {
  Block,
  FontsGroups,
  MapType,
  Project,
  ProjectPaths,
  ScormSettings,
  Section,
} from './types'
import { useReduxUpdate } from './useReduxUpdate'

interface IProjectProviderProps {
  path: ProjectPaths
  mode: PreviewMode
  project: Project
  sections: MapType<Section>
  blocks: MapType<Block>
  comments?: CommentMock[]
  tasks?: TaskMock[]
  fonts: FontsGroups
  scormSettings?: ScormSettings
  children: React.ReactNode
}

const ProjectProvider: React.FC<IProjectProviderProps> = ({
  children,
  mode,
  path,
  project,
  blocks,
  sections,
  fonts,
  comments = EMPTY_ARRAY,
  tasks = EMPTY_ARRAY,
  scormSettings,
}) => {
  useReduxUpdate(path, mode, project, sections, blocks, comments, tasks, scormSettings)

  return (
    <BrandProvider companyBrand={(project.brand as BrandType) || DEFAULT_BRAND}>
      <ProjectLabelsProvider value={project.localeSettings}>
        <UseAbsoluteSizes />
        <MediaProvider>
          {children}
          {mode !== PreviewMode.scorm && <FontsInjector fontGroups={fonts} />}
        </MediaProvider>
      </ProjectLabelsProvider>
    </BrandProvider>
  )
}

export default React.memo(ProjectProvider)
